import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import { connectModal, hide } from 'redux-modal';
import { useHistory } from 'react-router-dom';
import { sharePlace } from '../../actions/parkingSpotActions';
import { SHARE_PLACE_DONE_ROUTE } from '../router/routes';
import SharePlaceForm from './SharePlaceForm';

function SharePermanentSpotModal({ spotId }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleCancel = () => {
    dispatch(hide('sharePermanentPlaceModal'));
  };
  async function handleSubmit(values) {
    const reqData = {
      dateFrom: moment(values.dateFrom).format('DD.MM.YYYY'),
      dateTo: moment(values.dateTo).format('DD.MM.YYYY'),
      spotId
    };

    try {
      await dispatch(sharePlace(reqData));
      dispatch(hide('sharePermanentPlaceModal'));
      history.push(SHARE_PLACE_DONE_ROUTE);
    } catch (err) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error('Ups! Něco se nepovedlo, napište nám');
      }
    }
  }

  return (
    <div className="modal">
      <div className="modal__container">
        <div className="modal__body">
          <h2 className="sharemodal__header">Sdílet parkovací místo</h2>
          <SharePlaceForm
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
            spotId={spotId}
          />
        </div>
      </div>
    </div>
  );
}

export default connectModal({ name: 'sharePermanentPlaceModal' })(
  SharePermanentSpotModal
);
